import { useState, useEffect } from "react";
import axios from "axios";

const SECTIONS = ["header", "left_menu", "footer", "account_menu"];
let cache = null;
let inflight = null;
const listeners = new Set();

export function refreshSiteNavigation() {
  inflight = axios
    .get("/api/public/navigation", { withCredentials: true })
    .then((res) => {
      cache = res.data || {};
      inflight = null;
      listeners.forEach((l) => l(cache));
      return cache;
    })
    .catch(() => {
      inflight = null;
      return cache;
    });
  return inflight;
}

// Pick the correct label for the active language, with graceful fallback.
export function pageLabel(item, i18n) {
  const fr = (i18n?.language || "en").startsWith("fr");
  return fr
    ? item.label_fr || item.label_en || item.slug
    : item.label_en || item.label_fr || item.slug;
}

// section: one of header | left_menu | footer | account_menu. Omit for full map.
export function useSiteNavigation(section) {
  const [nav, setNav] = useState(cache);

  useEffect(() => {
    const l = (data) => setNav({ ...data });
    listeners.add(l);
    if (cache) setNav(cache);
    else if (!inflight) refreshSiteNavigation();
    return () => listeners.delete(l);
  }, []);

  const data = nav || {};
  if (section) return data[section] || [];
  return SECTIONS.reduce((acc, s) => ({ ...acc, [s]: data[s] || [] }), {});
}
